<template>
  <div class="card text-center p-0">
    <div class="card-body p-1">
      <p class="card-text p-0">
        <button v-on:click="$emit('more')" class="btn btn-outline-primary btn-block" type="button">
          <b>mehr News</b>
        </button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentStaticProviderMore"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
